export default {
      id: "youtube-usage",
      viewBox: "0 0 40 40",
      url: "/" + "sprite.svg#youtube",
      toString: function () {
        return this.url;
      }
    }